import React, { forwardRef } from 'react'
import './tooltip.style.scss'
import { CPopover } from '@coreui/react-pro'
import PropTypes from 'prop-types'
import { useTheme } from 'src/components/ThemeContext'

const Tooltip = forwardRef(({ content, placement, children, childClassName, darkText, ...rest }, ref) => {
  const { mode } = useTheme()

  // Determine the tooltip class based on the theme and darkText prop
  const tooltipClass = `${mode === 'dark' ? 'tooltip-light' : 'tooltip-dark'} ${
    darkText ? 'dark-text' : ''
  }`

  return (
    <CPopover
      content={
        <div className={`popover-body ${darkText ? 'dark-text' : ''}`}>
          {content}
        </div>
      } 
      placement={placement}
      trigger={'hover'} // You can also use 'click' as per requirement
      className={`popover-tooltip ${tooltipClass}`} // Apply theme-based and darkText classes
      {...rest}
    >
      {/* Forward ref to children (Button) */}
      <div ref={ref} className={childClassName}>
        {children}
      </div>
    </CPopover>
  )
})

Tooltip.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  placement: PropTypes.string,
  children: PropTypes.node.isRequired,
  childClassName: PropTypes.string,
  darkText: PropTypes.bool, 
}

Tooltip.defaultProps = {
  content: 'Enter tooltip content',
  placement: 'auto',
  darkText: false, 
}

export default Tooltip
